import { useCallback, useState } from 'react';
import { YouTubeLiveStream } from '../types';

// Preview modal open/close state only. The playout-server status polling now
// lives inside PreviewModal so that a status refresh re-renders just the modal,
// not the whole stream-list page (the table has nothing to do with it).
export function usePreviewPlayout() {
  const [previewStream, setPreviewStream] = useState<YouTubeLiveStream | null>(null);
  const [showPreview, setShowPreview] = useState(false);

  const openPreview = useCallback((stream: YouTubeLiveStream) => {
    setPreviewStream(stream);
    setShowPreview(true);
  }, []);

  const closePreview = useCallback(() => {
    setShowPreview(false);
    setPreviewStream(null);
  }, []);

  return {
    previewStream,
    showPreview,
    openPreview,
    closePreview
  };
}
